var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronDownArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 1.56168C16 1.95102 15.8549 2.33769 15.5737 2.60169L8.71631 9.03904C8.29229 9.43637 7.68656 9.43104 7.26826 9.02437L0.410867 2.35769C-0.0737222 1.88702 -0.138867 1.04568 0.264576 0.479014C0.668019 -0.0863209 1.38919 -0.162321 1.87378 0.30968L8.01228 6.27636L14.1405 0.523014C14.632 0.0616798 15.352 0.152347 15.7474 0.727015C15.9177 0.972348 16 1.26835 16 1.56168Z",
    fill: "#696677"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownArrow);
export default __webpack_public_path__ + "static/media/chevron-down-arrow.7c61b512ebb16546cd622a65efd3fb8c.svg";
export { ForwardRef as ReactComponent };